import { useState } from "react";
import "./A4ImageWithExpandable.css";

const A4ImageWithExpandable = ({
  mainImage,
  expandedImage,
  linkLabel = "Pokaż kolejną stronę",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  // Sprawdź czy expandedImage jest tablicą
  const isArray = Array.isArray(expandedImage);
  const imagesList = isArray ? expandedImage : [expandedImage];

  // Otwórz obraz w pełnym oknie
  const openFullscreen = (image) => {
    setCurrentImage(image);
    setIsModalOpen(true);
    // Zapobiegaj przewijaniu tła
    document.body.style.overflow = "hidden";
  };

  // Zamknij pełne okno
  const closeFullscreen = () => {
    setIsModalOpen(false);
    setCurrentImage(null);
    // Przywróć przewijanie tła
    document.body.style.overflow = "unset";
  };

  // Zamknij po kliknięciu ESC
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      closeFullscreen();
    }
  };

  return (
    <div className="a4-wrapper">
      {/* GŁÓWNY OBRAZ */}
      <div>
        <img 
          src={mainImage} 
          alt="Główny obraz" 
          className="a4-main-image"
          onClick={() => openFullscreen(mainImage)}
          style={{ cursor: "pointer" }}
        />
      </div>

      {/* LINK */}
      <button 
        className="a4-expand-button" 
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? "Ukryj stronę" : linkLabel}
      </button>

      {/* ROZWIJANY OBSZAR */}
      <div className={`a4-expandable ${isOpen ? "open" : ""}`}>
        <div className="a4-gallery">
          {imagesList.map((img, index) => (
            <div key={index}>
              <img 
                src={img} 
                alt={`Rozwijany obraz ${index + 1}`} 
                className="a4-full-image"
                onClick={() => openFullscreen(img)}
                style={{ cursor: "pointer" }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* MODAL - PEŁNY EKRAN */}
      {isModalOpen && (
        <div 
          className="a4-modal"
          onClick={closeFullscreen}
          onKeyDown={handleKeyDown}
          tabIndex={0}
        >
          <button 
            className="a4-modal-close"
            onClick={closeFullscreen}
            aria-label="Zamknij"
          >
            ✕
          </button>
          <img 
            src={currentImage} 
            alt="Pełny ekran" 
            className="a4-modal-image"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default A4ImageWithExpandable;